import { ClipboardIcon } from "@heroicons/react/20/solid";
import { connect } from "react-redux";
import { Link, useLocation, Navigate, Route, Routes } from "react-router-dom";
import ReportPacks from "./ReportPacks";
import ReportBuilder from "@/components/report/ReportBuilder";
import ReportsBulkClients from "./ReportsBulkClients";
import { Actions as REPORTACTIONS } from "../../../store/actions/reportActions";
import { useMemo } from "react";
import CustomReportList from "@/components/report/CustomReportList";

const tabs = [
	{
		link: "/advisor/reports/reportPacks",
		name: "Report Packs",
	},
	{
		link: "/advisor/reports/clients",
		name: "Clients",
	},
	{
		link: "/advisor/reports/customReports",
		name: "Custom Reports",
	},
];

const AdvisorReports = ({ getReportPacks, reportPacks, getCustomReports }) => {
	const location = useLocation();
	const currentTab = location.pathname;

	useMemo(() => {
		if (reportPacks) return;
		getReportPacks();
		getCustomReports();
	}, [tabs]);
	return (
		<>
			<div className="content bg-gray-lighter">
				<div className="row">
					<div className="col-sm-12">
						<div className="pull-left">
							<h1 className="page-heading">Reports</h1>
						</div>
					</div>
				</div>
			</div>
			<div className="content bg-white">
				<ul className="nav nav-tabs nav-tabs alt nav-justified">
					{tabs.map((tab) => {
						return (
							<li className={currentTab === tab.link ? "active" : ""}>
								<Link to={tab.link}>{tab.name}</Link>
							</li>
						);
					})}
				</ul>

				<Routes>
					<Route
						path="/reportPacks"
						element={<ReportPacks />}
					/>
					<Route
						path="/clients"
						element={<ReportsBulkClients />}
					/>
					<Route
						path="/customReports"
						element={<CustomReportList />}
					/>
					<Route
						path="/customReports/:id"
						element={<ReportBuilder isAdvisor={true} />}
					/>
					<Route
						path="*"
						element={
							<Navigate
								to="/advisor/reports/reportPacks"
								replace
							/>
						}
					/>
				</Routes>
			</div>
		</>
	);
};

const mapStateToProps = (state) => {
	return {
		reportPacks: state.advisors?.reports?.reportPacks,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getReportPacks: () => dispatch(REPORTACTIONS.getReportPacks()),
	getCustomReports: () => dispatch(REPORTACTIONS.getCustomReports()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdvisorReports);
